"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[700],{

/***/ 12433:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "OD": function() { return /* binding */ Lozenge; }
/* harmony export */ });
/* unused harmony exports rotationClasses, sizeClasses */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _colors__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51123);



var rotationClasses = {
    1: "rotate-[30deg]",
    2: "rotate-[60deg]",
    3: "rotate-[90deg]",
    4: "rotate-[120deg]",
    5: "rotate-[150deg]",
    6: "rotate-[180deg]",
    7: "rotate-[210deg]",
    8: "rotate-[240deg]",
    9: "rotate-[270deg]",
    10: "rotate-[300deg]",
    11: "rotate-[330deg]",
    12: "rotate-[360deg]"
};
var sizeClasses = {
    sm: "w-[52px] h-[92px]",
    md: "w-[82px] h-[147px]",
    lg: "w-[117px] h-[209px]",
    xl: "w-[141px] h-[252px]"
};
var Lozenge = function(param) {
    var color = param.color, size = param.size, rotation = param.rotation, className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(_colors__WEBPACK_IMPORTED_MODULE_2__/* .backgroundClasses */ .b0[color], sizeClasses[size], rotationClasses[rotation], "scale-[40%] tablet:scale-[60%] lg:scale-75 xl:scale-90 2xl:scale-100", "origin-center block rounded-full", className)
    });
};


/***/ }),

/***/ 90231:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ Button; }
/* harmony export */ });
/* unused harmony export ButtonMemo */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(67573);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(14251);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(52875);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _helpers_sitemap_isInternalLink__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(49853);
/* harmony import */ var _images_IconLoader__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(64162);
/* harmony import */ var _loaders_Spinner__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(58998);
/* harmony import */ var _Link__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(76609);










var variantClasses = {
    primary: "pyxis-btn-primary",
    secondary: "pyxis-btn-secondary",
    tertiary: "pyxis-btn-tertiary",
    brand: "pyxis-btn-brand",
    ghost: "pyxis-btn-ghost",
    white: "pyxis-btn-white"
};
var sizeClasses = {
    sm: "pyxis-btn-small",
    md: "pyxis-btn-medium",
    lg: "pyxis-btn-large",
    xl: "pyxis-btn-huge"
};
var iconSizeClasses = {
    sm: "w-4 h-4",
    md: "w-4 h-4",
    lg: "w-4 h-4",
    xl: "w-4 h-4"
};
var iconOnlySizeClasses = {
    sm: "w-10 h-10 md:w-10 md:h-10",
    md: "w-10 h-10 md:w-11 md:h-11",
    lg: "w-10 h-10 md:w-11 md:h-11",
    xl: "w-10 h-10 md:w-11 md:h-11"
};
var Button = function(props) {
    if ((0,_helpers_sitemap_isInternalLink__WEBPACK_IMPORTED_MODULE_6__/* .isInternalLink */ .F)(props.href)) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Link__WEBPACK_IMPORTED_MODULE_5__/* .Link */ .r, {
            href: props.href,
            locale: props.language,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ButtonInner, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, props), {
                as: "span"
            }))
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ButtonInner, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, props));
};
var ButtonMemo = /*#__PURE__*/ (/* unused pure expression or super */ null && (React.memo(Button)));
var ButtonInner = function(param) {
    var _as = param.as, as = _as === void 0 ? "a" : _as, _label = param.label, label = _label === void 0 ? "" : _label, href = param.href, onClick = param.onClick, target = param.target, _variant = param.variant, variant = _variant === void 0 ? "primary" : _variant, _size = param.size, size = _size === void 0 ? "lg" : _size, icon = param.icon, _iconPosition = param.iconPosition, iconPosition = _iconPosition === void 0 ? "after" : _iconPosition, _compact = param.compact, compact = _compact === void 0 ? false : _compact, ariaLabel = param.ariaLabel, _disabled = param.disabled, disabled = _disabled === void 0 ? false : _disabled, _loading = param.loading, loading = _loading === void 0 ? false : _loading, _download = param.download, download = _download === void 0 ? false : _download, _hideLabel = param.hideLabel, hideLabel = _hideLabel === void 0 ? false : _hideLabel, _stretch = param.stretch, stretch = _stretch === void 0 ? false : _stretch, _alt = param.alt, alt = _alt === void 0 ? false : _alt;
    var Element = as === "submit" ? "button" : as;
    var props = {
        type: null,
        href: null,
        target: null,
        download: null,
        title: null,
        disabled: null
    };
    if (target === "_blank") {
        icon = "external-link";
        iconPosition = "after";
    }
    if (hideLabel) {
        ariaLabel = props.title = label;
        label = "";
    }
    label = label || "";
    iconPosition = iconPosition || "after";
    // prevent orphan icon by adding first / last word to icon
    var labelWords = label === null || label === void 0 ? void 0 : label.split(" ");
    if (as === "button") {
        props.type = "button";
    }
    if (as === "submit") {
        props.type = "button";
    }
    if (as === "a") {
        props.href = href;
        props.target = target;
    }
    if (download) {
        var ref;
        props.download = true;
        if (((ref = props.href) === null || ref === void 0 ? void 0 : ref.indexOf(".sanity.io")) > -1) props.href = "".concat(props.href, "?dl");
    }
    if (disabled) {
        props.disabled = "disabled";
    }
    var handleClick = function(e) {
        return disabled ? function() {} : onClick ? onClick(e) : function() {};
    };
    var ButtonIcon = icon ? function(param) {
        var wordBefore = param.wordBefore, wordAfter = param.wordAfter;
        var _obj;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
            className: "whitespace-nowrap break-all",
            children: [
                wordBefore && " ".concat(wordBefore),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("inline text-current", iconSizeClasses[size], (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_obj, "mr-2", wordAfter), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_obj, "ml-2", wordBefore), _obj)),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_images_IconLoader__WEBPACK_IMPORTED_MODULE_3__/* .IconLoader */ .p, {
                        icon: icon,
                        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("inline-block translate-y-1", iconSizeClasses[size])
                    })
                }),
                wordAfter && "".concat(wordAfter, " ")
            ]
        });
    } : null;
    var _obj;
    var sharedClasses = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_obj, "pyxis-btn", true), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_obj, sizeClasses[size], true), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_obj, variantClasses[variant], true), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_obj, "pyxis-btn-alt", alt), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_obj, "inline-flex items-center justify-center", !stretch), _obj);
    // icon only button
    if (!(label === null || label === void 0 ? void 0 : label.trim().length)) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Element, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, props), {
            "aria-label": ariaLabel || label,
            onClick: handleClick,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(sharedClasses, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, iconOnlySizeClasses[size], !compact)),
                children: [
                    ButtonIcon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ButtonIcon, {}),
                    loading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ButtonLoader, {})
                ]
            })
        }));
    }
    // icon + text button
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Element, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, props), {
        "aria-label": ariaLabel || label,
        onClick: handleClick,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
            className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(sharedClasses, sizeClasses[size], (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, "w-full flex", stretch)),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "text-left break-words",
                children: ButtonIcon ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        ButtonIcon && iconPosition === "before" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ButtonIcon, {
                            wordAfter: labelWords[0]
                        }),
                        iconPosition === "before" ? labelWords.slice(1).join(" ") : labelWords.slice(0, -1).join(" "),
                        ButtonIcon && iconPosition === "after" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ButtonIcon, {
                            wordBefore: labelWords[labelWords.length - 1]
                        }),
                        loading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ButtonLoader, {})
                    ]
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                    className: "flex",
                    children: [
                        label,
                        loading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ButtonLoader, {})
                    ]
                })
            })
        })
    }));
};
var ButtonLoader = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        className: "h-5 w-5 inline-flex self-center align-middle ml-2 -mb-1",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_loaders_Spinner__WEBPACK_IMPORTED_MODULE_4__/* .Spinner */ .$, {})
    });
};


/***/ }),

/***/ 12901:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ ButtonGroup; }
/* harmony export */ });
/* unused harmony export ButtonGroupMemo */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67573);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14251);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90231);






var ButtonGroup = function(param) {
    var items = param.items, direction = param.direction, stretch = param.stretch, align = param.align, className = param.className;
    var _obj;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("flex-wrap gap-3 md:gap-4", (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, "flex-col", direction === "vertical"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, "inline-flex", !stretch), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, "flex w-full", stretch), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, "justify-start", direction === "horizontal" && align === "left"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, "justify-center", direction === "horizontal" && align === "center"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, "justify-end", direction === "horizontal" && align === "right"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, "items-start", direction === "vertical" && align === "left"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, "items-center", direction === "vertical" && align === "center"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, "items-end", direction === "vertical" && align === "right"), _obj), className),
        children: items === null || items === void 0 ? void 0 : items.map(function(item) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("flex-shrink-0 max-w-full", (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, "w-full", item.stretch)),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Button__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, item))
            }, item.label);
        })
    });
};
var ButtonGroupMemo = /*#__PURE__*/ (/* unused pure expression or super */ null && (React.memo(ButtonGroup)));


/***/ }),

/***/ 6893:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "t3": function() { return /* binding */ ResponsiveImage; }
});

// UNUSED EXPORTS: ImageMemo, getOriginalImageDimensions, getResponsiveImageUrl, imageBuilder

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(67573);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(80969);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@sanity/image-url/lib/browser/image-url.umd.js
var image_url_umd = __webpack_require__(6803);
var image_url_umd_default = /*#__PURE__*/__webpack_require__.n(image_url_umd);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./helpers/utils/number.ts
/**
 * Wraps a number when it breaches the defined range.
 *
 * wrap accepts a range, defined as a min and max.
 *
 * When a third number is provided:
 *
 * If it lies within the range, it is returned.
 * If it lies outside the range, it is wrapped back around:
 *
 * wrap(0, 1, 0.5); // 0.5
 * wrap(0, 1, 1.5); // 0.5
 */ var wrap = function(min, max, v) {
    var rangeSize = max - min;
    return ((v - min) % rangeSize + rangeSize) % rangeSize + min;
};
/**
 * Round a number to the nearest multiple of another number.
 */ var roundToNearest = function(multiple, v) {
    if (multiple === 0) return Math.round(v);
    return Math.round(v / multiple) * multiple;
};
/**
 * Random number between two numbers.
 */ var randomBetween = function(min, max) {
    return Math.random() * (max - min) + min;
};

// EXTERNAL MODULE: ./hooks/useDebounce.ts
var useDebounce = __webpack_require__(4841);
// EXTERNAL MODULE: ./components/meta/ScriptJsonLd.tsx
var ScriptJsonLd = __webpack_require__(18164);
;// CONCATENATED MODULE: ./components/images/ResponsiveImage.tsx











var imageBuilder = image_url_umd_default()({
    projectId: "k6y0mpps",
    dataset: "production"
});
var IMAGE_QUALITY = 85;
var ratioClasses = {
    auto: "aspect-auto",
    "1/1": "aspect-[1/1]",
    "3/2": "aspect-[3/2]",
    "16/9": "aspect-[16/9]",
    "19/27": "aspect-[19/27]",
    "2/1": "aspect-[2/1]",
    "13/8": "aspect-[13/8]",
    "4/3": "aspect-[4/3]",
    "21/9": "aspect-[21/9]"
};
var ResponsiveImage = function(param) {
    var src = param.src, width = param.width, height = param.height, crop = param.crop, hotspot = param.hotspot, _alt = param.alt, alt = _alt === void 0 ? "" : _alt, _layout = param.layout, layout = _layout === void 0 ? "intrinsic" : _layout, objectFit = param.objectFit, className = param.className, _preventResize = param.preventResize, preventResize = _preventResize === void 0 ? false : _preventResize, priority = param.priority, ratio = param.ratio, _roundSize = param.roundSize, roundSize = _roundSize === void 0 ? 0 : _roundSize, dpr = param.dpr;
    var wrapperRef = (0,react.useRef)(null);
    var placeholderRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(null), responsiveSrc = ref[0], setResponsiveSrc = ref[1];
    var ref1 = (0,react.useState)(null), state = ref1[0], setState = ref1[1];
    var ref2 = (0,react.useState)(0), wrapperWidth = ref2[0], setWrapperWidth = ref2[1];
    var ref3 = (0,react.useState)(0), wrapperHeight = ref3[0], setWrapperHeight = ref3[1];
    var debouncedWrapperWidth = (0,useDebounce/* useDebounce */.N)(wrapperWidth, 500);
    var debouncedWrapperHeight = (0,useDebounce/* useDebounce */.N)(wrapperHeight, 500);
    var originalDimensions = getOriginalImageDimensions(src);
    if (!width) width = originalDimensions === null || originalDimensions === void 0 ? void 0 : originalDimensions.width;
    if (!height) height = originalDimensions === null || originalDimensions === void 0 ? void 0 : originalDimensions.height;
    var aspectRatio = originalDimensions === null || originalDimensions === void 0 ? void 0 : originalDimensions.aspectRatio;
    var placeHolderSrc;
    // if (ratio) {
    //   height = (+width / +ratio.split(':')[0]) * +ratio.split(':')[1];
    // }
    if (src && typeof src === "string" && src.indexOf("sanity.io") > -1) {
        placeHolderSrc = getResponsiveImageUrl({
            src: src,
            width: 16,
            height: 16 / (+width / +height),
            hotspot: hotspot,
            crop: crop,
            blur: 10,
            dpr: dpr
        });
    }
    (0,react.useEffect)(function() {
        if (state === null) setState("loading");
    }, [
        state
    ]);
    var onResize = (0,react.useCallback)(function() {
        if (!src) return;
        if (!(wrapperRef === null || wrapperRef === void 0 ? void 0 : wrapperRef.current)) return;
        if (!placeHolderSrc) return;
        if (typeof src !== "string") return;
        var rect = wrapperRef.current.getBoundingClientRect();
        var w = roundToNearest(roundSize, rect.width);
        var h = roundToNearest(roundSize, rect.height);
        setWrapperWidth(w);
        setWrapperHeight(h);
    }, [
        src,
        placeHolderSrc,
        roundSize
    ]);
    /**
   * Listen to window resizes
   */ (0,react.useEffect)(function() {
        if (!src) return;
        if (!(wrapperRef === null || wrapperRef === void 0 ? void 0 : wrapperRef.current)) return;
        if (typeof ResizeObserver === "undefined") return;
        var resizeObserver = new ResizeObserver(onResize);
        resizeObserver.observe(wrapperRef.current);
        (function() {
            return resizeObserver.disconnect();
        });
    }, [
        wrapperRef,
        src,
        onResize
    ]);
    /**
   * when the debounced window width changes
   * generate new source for sanity images
   */ (0,react.useEffect)(function() {
        if (!src) return;
        if (!placeHolderSrc) return;
        if (typeof src !== "string") return;
        var rect = wrapperRef.current.getBoundingClientRect();
        var newWidth = roundToNearest(roundSize, rect.width);
        var newHeight = roundToNearest(roundSize, rect.height);
        var quality = IMAGE_QUALITY;
        if (preventResize === true) {
            // Do we need to factor in crops as well? https://github.com/sanity-io/hydrogen-sanity-demo/blob/main/src/components/SanityImage.client.jsx#L100
            newHeight = rect.width / (+width / +height);
            quality = null;
        }
        // for layouts where height depends on the image, use image ratio
        if (newHeight === 0) newHeight = newWidth / (+width / +height);
        setResponsiveSrc(getResponsiveImageUrl({
            src: src,
            width: newWidth,
            height: newHeight,
            hotspot: hotspot,
            crop: crop,
            quality: quality,
            dpr: dpr
        }));
    }, [
        wrapperWidth,
        debouncedWrapperHeight,
        width,
        height,
        src,
        crop,
        hotspot,
        preventResize,
        placeHolderSrc,
        roundSize, 
    ]);
    var onImageLoad = (0,react.useCallback)(function() {
        setState("loaded");
    }, []);
    var imageJsonLd = {
        "@context": "https://schema.org/",
        "@type": "ImageObject",
        contentUrl: src,
        description: alt
    };
    if (!src) return null;
    var _obj;
    return(// disable margin underneath next image until classes can be applied to next image directly
    // https://github.com/vercel/next.js/discussions/22861
    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()("image", "text-0 h-full w-full", (_obj = {}, (0,_define_property/* default */.Z)(_obj, "relative", !objectFit), (0,_define_property/* default */.Z)(_obj, ratioClasses[ratio], ratio), _obj)),
        ref: wrapperRef,
        children: [
            priority && responsiveSrc && /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                    rel: "preload",
                    as: "image",
                    href: "".concat(responsiveSrc, "&q=").concat(IMAGE_QUALITY)
                })
            }),
            (state === "loading" || state === "loaded") && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                src: responsiveSrc || placeHolderSrc || src,
                className: className,
                alt: alt,
                layout: layout,
                width: layout === "fill" ? null : width,
                height: layout === "fill" ? null : height,
                objectFit: objectFit,
                priority: priority,
                loader: function(param) {
                    var src = param.src, width = param.width, _quality = param.quality, quality = _quality === void 0 ? 100 : _quality;
                    return "".concat(src, "&q=").concat(quality);
                },
                quality: IMAGE_QUALITY,
                onLoadingComplete: onImageLoad
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("noscript", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("picture", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: src,
                        className: className,
                        alt: alt,
                        width: width ? width : "auto",
                        height: height ? height : "auto"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ScriptJsonLd/* ScriptJsonLd */.a, {
                data: imageJsonLd
            })
        ]
    }));
};
var ImageMemo = /*#__PURE__*/ (/* unused pure expression or super */ null && (React.memo(ResponsiveImage)));
function getResponsiveImageUrl(param) {
    var src = param.src, width = param.width, height = param.height, crop = param.crop, hotspot = param.hotspot, _blur = param.blur, blur = _blur === void 0 ? 0 : _blur, _quality = param.quality, quality = _quality === void 0 ? IMAGE_QUALITY : _quality, dpr = param.dpr;
    if (!src) return null;
    var ref = getOriginalImageDimensions(src), originalWidth = ref.width, originalHeight = ref.height;
    dpr = dpr ? dpr :  false ? 0 : window.devicePixelRatio || 1;
    var newSrc = imageBuilder.image(src).auto("format");
    if (quality) newSrc = newSrc.quality(IMAGE_QUALITY);
    if (blur) newSrc = newSrc.blur(blur);
    if (width) newSrc = newSrc.width(Math.ceil(width * dpr));
    if (height) newSrc = newSrc.height(Math.ceil(height * dpr));
    if ((hotspot === null || hotspot === void 0 ? void 0 : hotspot.x) && (hotspot === null || hotspot === void 0 ? void 0 : hotspot.y)) newSrc = newSrc.crop("focalpoint").focalPoint(hotspot.x, hotspot.y).fit("crop");
    if (crop && (crop === null || crop === void 0 ? void 0 : crop.left) !== null && (crop === null || crop === void 0 ? void 0 : crop.top) !== null && (crop === null || crop === void 0 ? void 0 : crop.right) !== null && (crop === null || crop === void 0 ? void 0 : crop.bottom) !== null) {
        var rect = {
            left: Math.floor(originalWidth * ((crop === null || crop === void 0 ? void 0 : crop.left) || 0)),
            top: Math.floor(originalHeight * ((crop === null || crop === void 0 ? void 0 : crop.top) || 0)),
            width: originalWidth - Math.floor(originalWidth * ((crop === null || crop === void 0 ? void 0 : crop.right) || 0)) - Math.floor(originalWidth * ((crop === null || crop === void 0 ? void 0 : crop.left) || 0)),
            height: originalHeight - Math.floor(originalHeight * ((crop === null || crop === void 0 ? void 0 : crop.bottom) || 0)) - Math.floor(originalHeight * ((crop === null || crop === void 0 ? void 0 : crop.top) || 0))
        };
        if (rect.width <= 0) rect.width = originalWidth;
        if (rect.height <= 0) rect.height = originalHeight;
        newSrc = newSrc.rect(rect.left, rect.top, rect.width, rect.height);
    }
    return newSrc.url();
}
function getOriginalImageDimensions(src) {
    var ref;
    if (!src) return {
        width: 0,
        height: 0,
        aspectRatio: 0
    };
    var filename = (ref = src === null || src === void 0 ? void 0 : src.split("/")) === null || ref === void 0 ? void 0 : ref.pop();
    var pattern = /-(\d+x\d+)/;
    var ref1 = (0,_sliced_to_array/* default */.Z)(pattern.exec(filename), 2), dimensions = ref1[1];
    var ref2 = (0,_sliced_to_array/* default */.Z)(dimensions.split("x").map(function(v) {
        return parseInt(v, 10);
    }), 2), width = ref2[0], height = ref2[1];
    var aspectRatio = width / height;
    return {
        width: width,
        height: height,
        aspectRatio: aspectRatio
    };
}


/***/ }),

/***/ 55237:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "xv": function() { return /* binding */ Text; }
/* harmony export */ });
/* unused harmony exports ALIGN_OPTIONS, SIZE_OPTIONS, FONT_OPTIONS, TextMemo */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67573);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _colors__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51123);
/* harmony import */ var _helpers_utils_object__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(21236);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23302);







var ALIGN_OPTIONS = (0,_helpers_utils_object__WEBPACK_IMPORTED_MODULE_5__/* .pick */ .e)(_types__WEBPACK_IMPORTED_MODULE_4__/* .ALIGNMENTS */ .Eu, "left", "center", "right", "auto");
var SIZE_OPTIONS = (0,_helpers_utils_object__WEBPACK_IMPORTED_MODULE_5__/* .pick */ .e)(_types__WEBPACK_IMPORTED_MODULE_4__/* .SIZES */ .zf, "sm", "md", "lg", "xl", "2xl");
var FONT_OPTIONS = (0,_helpers_utils_object__WEBPACK_IMPORTED_MODULE_5__/* .pick */ .e)(_types__WEBPACK_IMPORTED_MODULE_4__/* .FONTS */ .g5, "heading", "sans", "mono");
var alignClasses = {
    auto: "",
    left: "text-left",
    center: "text-center mx-auto",
    right: "text-right ml-auto"
};
var sizeClasses = {
    sm: "prose-sm md:prose-md",
    md: "prose-md md:prose-base",
    lg: "prose-lg md:prose-xl",
    xl: "prose-lg md:prose-2xl",
    "2xl": "prose-lg md:prose-2xl xl:prose-3xl"
};
var fontClasses = {
    sans: "font-sans",
    mono: "font-mono",
    heading: "font-sans"
};
var Text = function(param) {
    var children = param.children, _as = param.as, as = _as === void 0 ? "div" : _as, background = param.background, color = param.color, _align = param.align, align = _align === void 0 ? "left" : _align, _size = param.size, size = _size === void 0 ? "lg" : _size, className = param.className, _font = param.font, font = _font === void 0 ? "sans" : _font;
    var Element = as;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Element, {
            className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("break-words prose font-regular leading-relaxed", "prose-strong:font-bold prose-strong:text-current", "prose-a:underline prose-a:underline-offset-4", alignClasses[align], sizeClasses[size], fontClasses[font], color ? _colors__WEBPACK_IMPORTED_MODULE_3__/* .textClasses */ .Gb[color] : background ? _colors__WEBPACK_IMPORTED_MODULE_3__/* .proseClasses */ .fh[background] : "text-current", (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, "prose-a:text-action-base", !background || background === "white" || background === "neutral-95")),
            children: children
        })
    });
};
var TextMemo = /*#__PURE__*/ (/* unused pure expression or super */ null && (React.memo(Text)));


/***/ }),

/***/ 37794:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dx": function() { return /* binding */ Title; }
/* harmony export */ });
/* unused harmony exports SIZE_OPTIONS, WEIGHT_OPTIONS, TitleMemo */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67573);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _colors__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51123);
/* harmony import */ var _helpers_utils_object__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(21236);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23302);







var SIZE_OPTIONS = (0,_helpers_utils_object__WEBPACK_IMPORTED_MODULE_5__/* .pick */ .e)(_types__WEBPACK_IMPORTED_MODULE_4__/* .SIZES */ .zf, "xs", "sm", "md", "lg", "xl", "2xl", "3xl", "4xl");
var WEIGHT_OPTIONS = (0,_helpers_utils_object__WEBPACK_IMPORTED_MODULE_5__/* .pick */ .e)(_types__WEBPACK_IMPORTED_MODULE_4__/* .FONT_WEIGHTS */ .Xw, "book", "bold");
var sizeClasses = {
    xs: "text-title-xs-sm md:text-title-xs-md lg:text-title-xs-lg",
    sm: "text-title-sm-sm md:text-title-sm-md lg:text-title-sm-lg",
    md: "text-title-md-sm md:text-title-md-md lg:text-title-md-lg",
    lg: "text-title-lg-sm md:text-title-lg-md lg:text-title-lg-lg",
    xl: "text-title-xl-sm md:text-title-xl-md lg:text-title-xl-lg",
    "2xl": "text-title-2xl-sm md:text-title-2xl-md lg:text-title-2xl-lg",
    "3xl": "text-title-3xl-sm md:text-title-3xl-md lg:text-title-3xl-lg",
    "4xl": "text-title-4xl-sm md:text-title-4xl-md lg:text-title-4xl-lg"
};
var weightClasses = {
    book: "font-book",
    bold: "font-bold"
};
var Title = function(param) {
    var children = param.children, _as = param.as, as = _as === void 0 ? "h2" : _as, _size = param.size, size = _size === void 0 ? "sm" : _size, _weight = param.weight, weight = _weight === void 0 ? "bold" : _weight, className = param.className, _color = param.color, color = _color === void 0 ? "neutral-base" : _color, eyebrow = param.eyebrow, _eyebrowColor = param.eyebrowColor, eyebrowColor = _eyebrowColor === void 0 ? "brand-base" : _eyebrowColor;
    var ref;
    var Element = as;
    var titleWords = (ref = children === null || children === void 0 ? void 0 : children.toString()) === null || ref === void 0 ? void 0 : ref.trim().split(" ");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            eyebrow && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("block mb-[.5em]", sizeClasses.md, _colors__WEBPACK_IMPORTED_MODULE_3__/* .textClasses */ .Gb[eyebrowColor], (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, "opacity-75", eyebrowColor === "white")),
                children: [
                    eyebrow,
                    "\xa0"
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Element, {
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("break-words inline-block", "font-sans", "flex flex-col whitespace-pre-line", _colors__WEBPACK_IMPORTED_MODULE_3__/* .textClasses */ .Gb[color], sizeClasses[size], weightClasses[weight], className),
                children: typeof children === "string" ? titleWords.join(" ") : children
            })
        ]
    });
};
var TitleMemo = /*#__PURE__*/ (/* unused pure expression or super */ null && (React.memo(Title)));


/***/ }),

/***/ 4841:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ useDebounce; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/**
 * Usage:
 * const [searchTerm, setSearchTerm] = useState("");
 * const debouncedSearchTerm = useDebounce(searchTerm, 500);
 */ 
function useDebounce(value, delay) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(value), debouncedValue = ref[0], setDebouncedValue = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var handler = setTimeout(function() {
            setDebouncedValue(value);
        }, delay);
        return function() {
            return clearTimeout(handler);
        };
    }, [
        value,
        delay
    ]);
    return debouncedValue;
}


/***/ }),

/***/ 94349:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "TextImage": function() { return /* binding */ TextImage; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(67573);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(14251);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(52875);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _colors__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51123);
/* harmony import */ var _components_Decorations_Lozenge__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(12433);
/* harmony import */ var _components_buttons_ButtonGroup__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(12901);
/* harmony import */ var _components_images_ResponsiveImage__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6893);
/* harmony import */ var _components_module_Text__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(55237);
/* harmony import */ var _components_module_Title__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(37794);
/* harmony import */ var _components_module_Width__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(55668);
/* harmony import */ var _components_module_Wrapper__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(83118);














var TextImage = function(param) {
    var theme = param.theme, eyebrow = param.eyebrow, title = param.title, intro = param.intro, image = param.image, buttons = param.buttons;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11;
    var IMAGE_BACKGROUND_STYLES = {
        white: null,
        "lilac-base": null,
        "green-base": null,
        "blue-base": null,
        "coral-base": null,
        "orange-base": null,
        "yellow-base": null,
        "brand-base": "linear-gradient(243.9deg, #8334C2 0%, #5B2488 100%)"
    };
    var _obj, _obj1;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_module_Wrapper__WEBPACK_IMPORTED_MODULE_10__/* .Wrapper */ .i, {
        theme: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, theme === null || theme === void 0 ? void 0 : theme.module), {
            rounded: {
                top: theme === null || theme === void 0 ? void 0 : (ref = theme.decorations) === null || ref === void 0 ? void 0 : ref.roundedTop,
                bottom: theme === null || theme === void 0 ? void 0 : (ref1 = theme.decorations) === null || ref1 === void 0 ? void 0 : ref1.roundedBottom
            }
        }),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, "py-8 sm:py-10 lg:py-16 xl:py-20", theme === null || theme === void 0 ? void 0 : (ref2 = theme.module) === null || ref2 === void 0 ? void 0 : ref2.background)),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_module_Width__WEBPACK_IMPORTED_MODULE_9__/* .Width */ .L, {
                width: "inner",
                className: "relative",
                children: [
                    (theme === null || theme === void 0 ? void 0 : (ref3 = theme.decorations) === null || ref3 === void 0 ? void 0 : ref3.showLozenges) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("absolute z-20", "right-0 top-1/2 -translate-y-full"),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Decorations_Lozenge__WEBPACK_IMPORTED_MODULE_4__/* .Lozenge */ .OD, {
                            size: "lg",
                            color: (theme === null || theme === void 0 ? void 0 : (ref4 = theme.module) === null || ref4 === void 0 ? void 0 : ref4.background) === "neutral-95" ? "white" : "neutral-95",
                            rotation: 11
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "grid grid-cols-1 md:grid-cols-12 items-center md:items-start lg:items-center gap-10 lg:gap-16 xl:gap-20 relative z-30",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("order-2 flex flex-col gap-6 md:col-span-7", (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_obj, "-mt-3", eyebrow), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_obj, "-mt-2", !eyebrow), _obj)),
                                children: [
                                    (title || eyebrow) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_module_Title__WEBPACK_IMPORTED_MODULE_8__/* .Title */ .Dx, {
                                        size: (theme === null || theme === void 0 ? void 0 : (ref5 = theme.title) === null || ref5 === void 0 ? void 0 : ref5.size) || "3xl",
                                        color: "neutral-base",
                                        eyebrow: eyebrow,
                                        children: title
                                    }),
                                    intro && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_module_Text__WEBPACK_IMPORTED_MODULE_7__/* .Text */ .xv, {
                                        color: "neutral-25",
                                        size: "lg",
                                        children: intro
                                    }),
                                    buttons && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_buttons_ButtonGroup__WEBPACK_IMPORTED_MODULE_5__/* .ButtonGroup */ .i, {
                                        items: buttons,
                                        className: "mt-2"
                                    })
                                ]
                            }),
                            image && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("md:col-span-5 relative h-full md:px-5 tablet:px-16 lg:px-5 xl:px-10 2xl:px-[72px]", "xl:-translate-y-6", (theme === null || theme === void 0 ? void 0 : (ref6 = theme.image) === null || ref6 === void 0 ? void 0 : ref6.align) === "right" ? "order-1 md:order-3" : "order-1 md:order-1"),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("max-w-[70%] xs:max-w-[60%] sm:max-w-1/2 min-w-[160px] md:max-w-none relative  md:aspect-[380/540]", (_obj1 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_obj1, "aspect-[380/540]", (theme === null || theme === void 0 ? void 0 : (ref7 = theme.image) === null || ref7 === void 0 ? void 0 : ref7.orientationMobile) === "portrait"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_obj1, "aspect-[540/380]", (theme === null || theme === void 0 ? void 0 : (ref8 = theme.image) === null || ref8 === void 0 ? void 0 : ref8.orientationMobile) !== "portrait"), _obj1)),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("absolute w-full h-full z-10 overflow-hidden", "rounded-lg md:rounded-3xl lg:rounded-4xl", "origin-top-left -rotate-[12deg] md:origin-center md:-rotate-[8deg]", "translate-y-5 translate-x-2 md:translate-x-0 md:translate-y-10", _colors__WEBPACK_IMPORTED_MODULE_3__/* .backgroundClasses */ .b0[(theme === null || theme === void 0 ? void 0 : (ref9 = theme.image) === null || ref9 === void 0 ? void 0 : ref9.background) || "brand-base"]),
                                                style: {
                                                    background: IMAGE_BACKGROUND_STYLES[(theme === null || theme === void 0 ? void 0 : (ref10 = theme.image) === null || ref10 === void 0 ? void 0 : ref10.background) || "brand-base"]
                                                }
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_images_ResponsiveImage__WEBPACK_IMPORTED_MODULE_6__/* .ResponsiveImage */ .t3, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, image), {
                                                roundSize: 25,
                                                layout: "fill",
                                                className: "rounded-lg md:rounded-3xl lg:rounded-4xl overflow-hidden z-20"
                                            }))
                                        ]
                                    }),
                                    (theme === null || theme === void 0 ? void 0 : (ref11 = theme.decorations) === null || ref11 === void 0 ? void 0 : ref11.showLozenges) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("absolute z-20", "-translate-y-1/2", "top-1/2", "left-[70%] xs:left-[60%] sm:left-1/2 md:left-auto md:-right-5 tablet:right-0"),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Decorations_Lozenge__WEBPACK_IMPORTED_MODULE_4__/* .Lozenge */ .OD, {
                                            size: "md",
                                            color: "action-light",
                                            rotation: 2
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.memo(TextImage));


/***/ })

}]);